"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TextField_1 = require("../../../../../common/TextField");
var PurchaseOrderNumber = function (props) {
    return (React.createElement(TextField_1.default, { name: "purchase_order_number", value: props.value, validator: props.validator, label: window.location.href.includes('page9')
            ? 'Purchase Order Number'
            : 'Do you have a purchase order number for the goods/services provided?', onChange: function (value) {
            if (props.setFieldTouched) {
                props.setFieldTouched('purchase_order_number', true, true);
            }
            props.setFieldValue('purchase_order_number', value);
        }, placeholder: 'Job reference', disabled: false }));
};
exports.default = PurchaseOrderNumber;
